export default "__VITE_ASSET__Cym47nPb__"